import store from '@/store';
// import path from 'path';

// export function leadingSlash(str) {
//   return str.startsWith('/') ? str : '/' + str
// }
//
// export function trailingSlash(str) {
//   return str.endsWith('/') ? str : str + '/'
// }
//
import AlertDialog from "../views/dialog/AlertDialog";

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}
//
// export function formatModel(model, ignore = []) {
//   const keys = Object.keys(model)
//   const data = {}
//   // ignore.push('created_at');
//   // ignore.push('updated_at');
//   for (let i = 0; i < keys.length; i++) {
//     const key = keys[i]
//     if (ignore.indexOf(key) >= 0) continue
//     data[key] = model[key]
//   }
//   // console.log("formatModel", data);
//   return data
// }
//
// export function parseError(response) {
//   const data = response.data
//   if (response.status === 404) {
//     return {text: '找不到路徑', title: '錯誤'};
//   } else if (data !== undefined && data.error !== undefined) {
//     let text = data.error.text;
//     switch (data.error.code) {
//       case 'data_unique_fail': {
//         const fields = Object.keys(data.error.param.fields);
//         const params = [];
//         for (const field of fields) {
//           switch (field) {
//             case 'date':
//               params.push('日期');
//               break;
//           }
//         }
//         if (params.length > 0) {
//           text += ' : ' + params.join(', ');
//         }
//       }
//         break;
//     }
//     return {text: text, title: '錯誤'};
//   } else {
//     return undefined;
//   }
// }
//
export async function checkError(dialog, response) {
  const data = response.data
  if (data !== undefined && data.error !== undefined) {
    store.dispatch('hideLoading');
    await dialog.show(AlertDialog, {text: data.error.text});
    return false
  } else {
    return true
  }
}

//
// export function getColor(value, header, formattedValue) {
//   // console.log('get color : ', value, formattedValue, header);
//   if (header.color !== undefined) return header.color;
//   if (header.color_map !== undefined && header.color_map[value] !== undefined) {
//     return header.color_map[value];
//   }
//   if (value === undefined) value = formattedValue;
//   switch (value) {
//     case true:
//     case '是':
//     case 'success':
//       return 'success'
//     case false:
//     case '否':
//     case 'primary':
//       return 'primary'
//     case 'secondary':
//       return 'secondary';
//     case 'accent':
//       return 'accent';
//     case 'info':
//       return 'info';
//     case 'warning':
//       return 'warning';
//     case 'error':
//       return 'error';
//     default:
//       return '';
//   }
// }
//
// export function getThumbUrl(host, item) {
//   if (item === undefined) return undefined;
//   let media;
//   if (item.Media !== undefined) {
//     media = item.Media;
//   } else if (item.Medias !== undefined && item.Medias.length > 0) {
//     media = item.Medias[0];
//   }
//   if (media === undefined) return undefined;
//   if (media.url !== undefined && media.url !== null) host = media.url;
//   if (media.custom_properties.conversions === undefined || media.custom_properties.conversions.thumb !== true) {
//     return host + (media.destination + '/' + media.file_name);
//   }
//
//   return host + (media.destination + '/thumb/' + media.file_name);
// }

import {VUE_APP_HOST} from "./globals";

export function isEmpty(value) {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === 'object' && Object.keys(value).length === 0) return true;
  return value.toString().length === 0;
}

// export function getValue(item, keys) {
//   const isArray = keys[0].endsWith('[]');
//   const key = keys[0].replace('[]', '');
//   if (keys.length === 1) {
//     return item[key];
//   } else if (isArray) {
//     return item[key].map(v => getValue(v, keys.slice(1))).filter(v => !isEmpty(v));
//   } else {
//     return getValue(item[key], keys.slice(1));
//   }
// }
//
// export function getMedia(item) {
//   if (item === undefined || item === null) return undefined;
//   if (item.Media !== undefined && item.Media !== null) return item.Media;
//   if (item.Medias !== undefined && item.Medias.length > 0) return item.Medias[0];
//   if (item.destination !== undefined && item.file_name !== undefined) return item;
//   return item;
// }
//
export function getMedia(item, key = "Cover") {
  if (item === undefined) return undefined;
  if (item[key] !== undefined) return item[key];
  if (item[key] !== undefined && item[key].length > 0) return item.item[key][0];
  if (item.destination !== undefined && item.file_name !== undefined) return item;
  return item;
}

export function getMediaUrl(item, key) {
  const media = getMedia(item, key);
  if (media === undefined || media === null) return undefined;
  // console.log('getMediaUrl : ', media);
  const host = media.url !== null ? media.url : VUE_APP_HOST;
  // console.log('host : ', host);
  // console.log('destination : ', media.destination);
  // console.log('file_name : ', media.file_name);
  let url = host + (media.destination + '/' + media.file_name);
  // let url = host + (media.destination + '/medium/' + media.file_name);
  if (media.custom_properties === undefined ||
      media.custom_properties.conversions === undefined ||
      media.custom_properties.conversions.thumb !== true) {
    url = host + (media.destination + '/' + media.file_name);
  }
  // console.log('get file : ', url);
  return url;
}


export function getUrl(item) {
  const media = getMedia(item);
  // console.log('getUrl : ', media);
  if (media === undefined || media === null) return undefined;
  const url = media.url !== null && media.url !== undefined ? media.url : VUE_APP_HOST;
  return url + path.join(media.destination, media.file_name);
}

export function getPrice(text) {
  let num = Number(text);
  return num.toLocaleString('en-US');
}

//
// export function deepClone(target, source) {
//   const keys = Object.keys(source);
//   for (let i = 0; i < keys.length; i++) {
//     const key = keys[i];
//     if (key.startsWith('__')) continue;
//     if (source[key] === null || source[key] === undefined) continue;
//     if (Array.isArray(source[key])) {
//       target[key] = [];
//       for (const item of source[key]) {
//         const newItem = deepClone({}, item);
//         target[key].push(newItem);
//       }
//     } else if (typeof source[key] === 'object') {
//       target[key] = deepClone({}, source[key]);
//     } else if (typeof source[key] !== 'function') {
//       target[key] = source[key];
//     }
//   }
//   return target;
// }
//
// export function fillEmpty(v) {
//   if (!!v) return v;
//   return '';
// }
//
// export function initField(map, key, field) {
//   // console.log('initField : ', key, field);
//   let v;
//   switch (field.type) {
//     case 'card':
//       v = [];
//       break;
//     case 'list':
//       v = {};
//       break;
//     case 'media':
//       v = field.multiple ? [] : {};
//       break;
//   }
//   if (typeof field.default === 'object') {
//     v = JSON.parse(JSON.stringify(field.default));
//   } else {
//     v = field.default;
//   }
//   return v;
// }
//
// export function newTypeFixed(itemFields) {
//   // console.log('newTypeFixed : ' + JSON.stringify(itemFields, null, 4))
//   const map = {}
//   const keys = Object.keys(itemFields);
//   // let params = this.$route.params;
//   // console.log('keys : ', keys.length)
//   for (let i = 0; i < keys.length; i++) {
//     // console.log('\t|_ key : ', keys[i])
//     const key = keys[i];
//     const field = itemFields[key];
//     map[field.key ?? key] = initField(map, key, itemFields[key]);
//   }
//   return map;
// }
//
// export function generateMachineUuid() {
//   return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
// }
//
// export function getColClass(index) {
//   if (index % 2 === 0) {
//     return 'main1' // 偶數，綠色 EEF5F6
//   } else {
//     return 'white';// 基數，白色
//   }
// }


export async function copyText(text) {
  try {
    if (isEmpty(text) === false) {
      console.log('clickCopy ', text);
      let canCopy = false;

      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = text; // 复制目标元素的内容到 input
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // 适用于移动设备
      try {
        document.execCommand('copy'); // 使用旧版复制命令
        canCopy = true;
        return canCopy;
      } catch (err) {
        console.log('Failed to copy text: ', err);
      } finally {
        // 清理临时元素
        document.body.removeChild(tempInput);
      }

      try {
        //只支援 https
        await navigator.clipboard.writeText(text);
        canCopy = true;
      } catch (e) {
        console.log("message:push", "複製失敗", "warning");
      }
      return canCopy;
    }
  } catch (e) {
    console.log('error clickCopy :', e);
    return false;
  }
}
